<template>
  <div class="info-card">
    <div class="info-card__icon-wrapper" :class="iconColor">
      <i class="info-card__icon icon" :class="icon"></i>
    </div>
    <h3 ref="title" class="info-card__title">{{ title }}</h3>
    <h3 ref="subtitle" class="info-card__subtitle">{{ subtitle }}</h3>
    <hr ref="separator" class="info-card__separator" :class="iconColor" />
    <p ref="text" class="info-card__text">{{ text }}</p>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    icon: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    subtitle: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    },
    iconColor: {
      type: String,
      default: "red",
      validator(value) {
        return ["red", "yellow", "green"].includes(value)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.info-card {
  width: 100%;
  padding: $space-10 $space-10;
  @include sm {
    padding: $space-12 $space-10;
  }

  color: $day;
  background-color: $black;

  &__icon-wrapper {
    width: $space-15;
    height: $space-15;
    padding: $space-6;
  }

  &__icon {
    font-size: $font-size-7;
    margin: auto;
    color: $day;
  }

  &__title {
    margin-top: $space-6;
    margin-bottom: 0;
  }

  &__subtitle {
    font-weight: $weight-normal;
  }

  &__separator {
    display: block;
    width: 100%;
    height: $space-1;
  }

  &__text {
    font-size: $font-size-5;
  }
}

.red {
  background-color: $red-600;
}

.yellow {
  background-color: $sun;
}

.green {
  background-color: $earth;
}
</style>
